.root {
  &[data-variant='content'],
  &[data-variant='content-disabled'] {
    --paper-radius: var(--mantine-radius-lg);
    padding: var(--mantine-spacing-lg);
    border: 1px solid var(--mantine-color-gray-2);

    input {
      --input-size: 44px;
    }
  }

  &[data-variant='content-disabled'] {
    background-color: var(--mantine-color-gray-0);
  }

  &[data-variant='card'] {
    --paper-radius: var(--mantine-radius-lg);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    border: 1px solid var(--mantine-color-gray-2);
    background-color: var(--mantine-color-white);
  }
}
